import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { DomainType, PortalClientSecurityRight, PortalEntity, PortalTenantSetting, SecurityRoleTiny, TenantUser } from '@jms/model';
import { Select } from '@jms/shared/ngrx-actions';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;
import * as Enumerable from 'linq';
import { map, Observable } from 'rxjs';
import { ApplicationPermission, ApplicationSettings } from './application.model';

@Injectable()
export class ApplicationSelectors {

    @Select('application.settings')
    public settings$: Observable<ApplicationSettings>;

    @Select('application.token')
    public token$: Observable<string>;

    @Select('application.activeRole')
    public activeRole$: Observable<SecurityRoleTiny>;

    @Select('application.entities')
    public entities$: Observable<PortalEntity[]>;

    @Select('application.selectedEntity')
    public selectedEntity$: Observable<PortalEntity>;

    @Select('application.selectedTenantSetting')
    public selectedTenantSetting$: Observable<PortalTenantSetting>;

    @Select('application.user')
    public user$: Observable<TenantUser>;

    public permission$: Observable<ApplicationPermission>;

    public isPhone$: Observable<boolean>;

    constructor(
        breakpoints: BreakpointObserver
    ) {
        this.permission$ = this.activeRole$.pipe(
            map(role => {
                const rights = role?.rights ?? [];

                const newJob = Enumerable
                    .from(rights)
                    .any(right => right === PortalClientSecurityRight.RequestNewJob);

                const newQuote = Enumerable
                    .from(rights)
                    .any(right => right === PortalClientSecurityRight.RequestNewQuote);

                return {
                    newJob: newJob,
                    newQuote: newQuote
                }
            })
        );

        this.isPhone$ = breakpoints.observe(Breakpoints.Handset)
            .pipe(
                map(x => x.matches),
                map(x => x && ConfigService.environment.domainType === DomainType.ClientPortal)
            );
    }

}


